import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Typography,
  Paper,
  Box,
  Avatar,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert,
  Skeleton,
  Divider,
  Chip,
  CircularProgress,
  DialogContentText,
  Tooltip,
  styled,
  Grid,
} from "@mui/material";
import {
  ThumbUp as ThumbUpIcon,
  ThumbUpOutlined as ThumbUpOutlinedIcon,
  Reply as ReplyIcon,
  AccessTime as TimeIcon,
  ArrowBack as ArrowBackIcon,
  Person as PersonIcon,
  DeleteRounded,
  EditRounded,
} from "@mui/icons-material";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { fetchPostDetails, fetchComments, toggleLike } from "../MockApi";
import AnchorTemporaryDrawer from "../ReplyDrawer";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import EditDialog from "../Edit-Dialog";
import { useSnackbar } from "notistack";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: "black",
    color: "white",
    fontSize: 12,
  },
});
const SinglePostView = () => {
  const { postId } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const { state } = useLocation() || {};

  const { post: initialPostData, message } = state || {};
  useEffect(() => {
    if (message) {
      enqueueSnackbar(message, {
        variant: "success",
        autoHideDuration: 1500,
      });
    }
  }, [message, enqueueSnackbar]);

  const navigate = useNavigate();

  // const isAuthenticated = localStorage.getItem("isAuthenticated");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("isAuthenticated")?.toLowerCase() === "true";

    if (query) localStorage.setItem("isAuthenticated", "true");

    const local = localStorage.getItem("isAuthenticated") === "true";
    setIsAuthenticated(local);
  }, [location.search]);

  const [post, setPost] = useState(initialPostData || null);

  console.log("post_Aurther", post?.isAuthor)
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(!initialPostData);
  const [commentsLoading, setCommentsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [loginDialogOpen, setLoginDialogOpen] = useState(false);
  const [likedItems, setLikedItems] = useState(new Set());
  const [likeCounts, setLikeCounts] = useState({});
  const [commentsPage, setCommentsPage] = useState(1);
  const [hasMoreComments, setHasMoreComments] = useState(true);
  // LIGHT BOX STATES
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const baseUrl = process.env.REACT_APP_HOST_API;
  const slides = useMemo(() => {
    return (
      post?.imageUrls?.map((url) => ({
        src: `${baseUrl}${url}`,
      })) || []
    );
  }, [post, baseUrl]);

  const [confirmState, setConfirmState] = useState({
    open: false,
    type: null,
    id: null,
  });
  const [editState, setEditState] = useState({
    open: false,
    type: null,
    id: null,
    content: "",
  });

  const handleOpenEdit = (type, id, content) => {
    setEditState({ open: true, type, id, content });
  };

  const handleCloseEdit = () => {
    setEditState({ open: false, type: null, id: null, content: "" });
  };

  const handleSaveEdit = async (newValue, categoryId, title) => {
    try {
      handleCloseEdit();
      if (editState.type === "post") {
        setLoading(true);
      } else {
        setCommentsLoading(true);
        setComments([]);
      }

      const url =
        editState.type === "post"
          ? `${baseUrl}/forum/update-post`
          : `${baseUrl}/forum/edit-comment`;

      const payload =
        editState.type === "post"
          ? {
              postId: editState.id,
              query_text: `${newValue}`,
              categoryId: categoryId,
              title: title,
            }
          : { commentId: editState.id, commentText: `${newValue}` };

      const response = await axios.put(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (editState.type === "post") {
        const updatedPostData = response.data.updatedPost;

        setPost((prevPost) => ({
          ...prevPost,
          body: updatedPostData.query_text,
          title: updatedPostData.title,
        }));
      } else {
        loadComments(1, false);
      }

      enqueueSnackbar("Content updated successfully!", {
        variant: "success",
        autoHideDuration: 1500,
      });
    } catch (err) {
      console.error("Error updating:", err);
      enqueueSnackbar("Failed to update content.", {
        variant: "error",
        autoHideDuration: 1500,
      });
    } finally {
      if (editState.type === "post") {
        setLoading(false);
      } else {
        setCommentsLoading(false);
      }
    }
  };

  const openConfirm = (type, id = null) => {
    setConfirmState({ open: true, type, id });
  };

  const closeConfirm = () => {
    setConfirmState({ open: false, type: null, id: null });
  };

  const confirmDelete = () => {
    if (confirmState.type === "post") {
      handleDeletePost();
    } else if (confirmState.type === "comment") {
      handleDeleteComment(confirmState.id);
    }
    closeConfirm();
  };

  const raw = localStorage.getItem("localuser-storage");
  const userdata = raw ? JSON.parse(raw) : null;

  const userId = userdata?.state?.localuser?.userid;

  const { ref: commentsEndRef, inView: commentsInView } = useInView({
    threshold: 0.1,
    triggerOnce: false,
  });

  const loadComments = async (pageNumber = 1, isLoadMore = false) => {
    if (!isLoadMore) {
      setCommentsLoading(true);
      setComments([]);
    } else {
      setCommentsLoading(true);
    }
    try {
      const commentsResponse = await axios.post(
        `${baseUrl}/forum/posts/comments?page=${pageNumber}`,
        { postId, userId }
      );
      const newComments = commentsResponse?.data?.data?.comments || [];
      const pagination = commentsResponse?.data?.data?.pagination;

      // This is the new, correct place to update like COUNTS for subsequent pages
      setLikeCounts((prevCounts) => {
        const newCounts = { ...prevCounts };
        newComments.forEach((c) => {
          newCounts[`comment-${c._id}`] = c.totalLikes;
        });
        return newCounts;
      });

      setComments((prev) =>
        isLoadMore ? [...prev, ...newComments] : newComments
      );
      setHasMoreComments(pagination.currentPage < pagination.totalPages);
    } catch (err) {
      console.error("Failed to load comments:", err);
      setError("Failed to load comments.");
    } finally {
      setCommentsLoading(false);
    }
  };

  const loadInitialData = async () => {
    try {
      setLoading(true);
      setCommentsLoading(true);
      setError(null);

      // Fetch post details AND the first page of comments together
      const [postDetailsResponse, initialCommentsResponse] = await Promise.all([
        axios.post(`${baseUrl}/forum/image`, { postId, userId }),
        axios.post(`${baseUrl}/forum/posts/comments?page=1`, {
          postId,
          userId,
        }),
      ]);
      const isOwner =
        initialCommentsResponse.data.data.comments?.commentorId === userId;

      const postData = postDetailsResponse.data.data;
      console.log("postData_postData", postData)
      const finalPost = {
        _id: postId,
        title: initialPostData?.title,
        authorName: initialPostData?.authorName,
        createdAt: initialPostData?.createdAt,
        totalLikes: initialPostData?.totalLikes,
        imageUrls: postData?.images || [],
        body: initialPostData?.query_text,
        isLiked: postData.isPostLiked,
        isAuthor: postData.isAuthor,
        isOwner: isOwner,
      };
      setPost(finalPost);

      const initialComments = initialCommentsResponse.data.data.comments || [];
      const pagination = initialCommentsResponse.data.data.pagination;
      setComments(initialComments);
      setHasMoreComments(pagination.currentPage < pagination.totalPages);

      // This is now the SINGLE SOURCE OF TRUTH for setting initial like statuses
      const newLikedItems = new Set();
      const newLikeCounts = {};

      // Set for post
      if (finalPost.isLiked) {
        newLikedItems.add(`post-${finalPost._id}`);
      }
      newLikeCounts[`post-${finalPost._id}`] = finalPost.totalLikes;

      // Set for initial comments
      initialComments.forEach((comment) => {
        if (comment.isLiked) {
          newLikedItems.add(`comment-${comment._id}`);
        }
        newLikeCounts[`comment-${comment._id}`] = comment.totalLikes;
      });

      setLikedItems(newLikedItems);
      setLikeCounts(newLikeCounts);
    } catch (err) {
      setError("Failed to load post. It may not exist.");
      console.error("Load post error:", err);
    } finally {
      setLoading(false);
      setCommentsLoading(false);
    }
  };
  useEffect(() => {
    loadInitialData();
    setCommentsPage(1);
  }, [postId, userId]);

  useEffect(() => {
    if (commentsInView && hasMoreComments && !commentsLoading) {
      const nextPage = commentsPage + 1;
      setCommentsPage(nextPage);
      loadComments(nextPage, true);
    }
  }, [commentsInView, hasMoreComments, commentsLoading, commentsPage]);

  const token = localStorage.getItem("token");

  const handleLike = async (itemId, itemType) => {
    if (!isAuthenticated) {
      setLoginDialogOpen(true);
      return;
    }

    const key = `${itemType}-${itemId}`;
    const wasLiked = likedItems.has(key);
    const newStatus = !wasLiked;

    // Optimistic UI update for the liked state (icon change)
    const newLikedItems = new Set(likedItems);
    if (wasLiked) {
      newLikedItems.delete(key);
    } else {
      newLikedItems.add(key);
    }
    setLikedItems(newLikedItems);

    setLikeCounts((prev) => ({
      ...prev,
      [key]: (prev[key] || 0) + (wasLiked ? -1 : 1),
    }));

    try {
      if (itemType === "post") {
        await axios.post(
          `${baseUrl}/forum/post-like`,
          {
            userId: userId,
            postId: itemId,
            status: newStatus,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else if (itemType === "comment") {
        await axios.post(
          `${baseUrl}/forum/comment-like`,
          {
            userId: userId,
            commentId: itemId,
            status: newStatus,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
    } catch (err) {
      console.error("Failed to update like status:", err);
      enqueueSnackbar("Failed to update like. Please try again.", {
        variant: "error",
        autoHideDuration: 1500,
      });
      // Revert the state to what it was before the click
      setLikedItems(likedItems);
      setLikeCounts((prev) => ({
        ...prev,
        [key]: (prev[key] || 0) + (wasLiked ? 1 : -1),
      }));
    }
  };

  const handleReply = async (replyText) => {
    if (!isAuthenticated) {
      setLoginDialogOpen(true);
      return;
    }
    if (!token) {
      enqueueSnackbar("Authentication token not found. Please log in again.", {
        variant: "success",
        autoHideDuration: 1500,
      });
      return;
    }

    try {
      const response = await axios.post(
        `${baseUrl}/forum/add-comment`,
        {
          postId: postId,
          userId: userId,
          commentText: replyText,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        enqueueSnackbar("Comment added successfully!", {
          variant: "success",
          autoHideDuration: 1500,
        });
        setCommentsPage(1);
        setHasMoreComments(true);
        loadComments(1, false); //
      } else {
        throw new Error(
          response.data.message || "Server responded with an error."
        );
      }
    } catch (err) {
      console.error("Failed to add comment:", err);
      enqueueSnackbar("Failed to add comment. Please try again.", {
        variant: "error",
        autoHideDuration: 1500,
      });
      setCommentsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));

    if (diffInHours < 1) return "Just now";
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInHours < 48) return "Yesterday";
    return date.toLocaleDateString();
  };

  const handleBackClick = () => {
    navigate(-1);
  };
  const categoryId =
    state?.post?.categoryDetails?.[0]?._id || state?.post?.categoryId;

  const handleDeleteComment = async (commentId) => {
    try {
      const response = await axios.delete(`${baseUrl}/forum/delete-comment`, {
        data: {
          userId: userId,
          commentId: commentId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error(
        "Delete post failed:",
        error.response?.data || error.message
      );
      enqueueSnackbar("Failed to delete post", {
        variant: "error",
        autoHideDuration: 1500,
      });
    } finally {
      loadComments(1, false);
      enqueueSnackbar("Comment deleted Successfully!", {
        variant: "success",
        autoHideDuration: 1500,
      });
    }
  };
  
  const handleDeletePost = async () => {
    try {
      const response = await axios.delete(`${baseUrl}/forum/delete-post`, {
        data: {
          postId: postId,
          userId: userId,
          categoryId: categoryId,
          title: post?.title,
          query_text: post?.body,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const successMessage =
        response.data.message || "Post deleted successfully";

      sessionStorage.setItem("flashMessage", successMessage);

      navigate("/ForumsCategory");
    } catch (error) {
      console.error(
        "Delete post failed:",
        error.response?.data || error.message
      );
      enqueueSnackbar("Failed to delete post", {
        variant: "error",
        autoHideDuration: 1500,
      });
    }
  };
  const navigateLogin = () => {
    navigate("/login");
  };

  const renderPostSkeleton = () => (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        mb: 3,
        bgcolor: "#212930",
        borderRadius: 5,
        boxShadow:
          "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
        border: "1px solid #323d49",
      }}
    >
      {/* Title + Delete */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Skeleton variant="text" width="70%" height={32} />
        <Skeleton variant="circular" width={32} height={32} />
      </Box>

      {/* Author Info */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
        <Box>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="text" width={80} height={16} />
        </Box>
      </Box>

      {/* Body */}
      <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="95%" height={20} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="90%" height={20} sx={{ mb: 2 }} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={150}
        sx={{ mb: 3, borderRadius: 2 }}
      />

      {/* Footer Buttons */}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Skeleton
          variant="rectangular"
          width={80}
          height={36}
          sx={{ borderRadius: 5 }}
        />
        <Skeleton
          variant="rectangular"
          width={120}
          height={36}
          sx={{ borderRadius: 5 }}
        />
      </Box>
    </Paper>
  );

  const renderCommentsSkeleton = () => (
    <Paper
      elevation={1}
      sx={{
        p: 3,
        bgcolor: "#212930",
        borderRadius: 5,
        boxShadow:
          "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
        border: "1px solid #323d49",
      }}
    >
      <Skeleton variant="text" width={200} height={32} sx={{ mb: 2 }} />
      {[...Array(3)].map((_, index) => (
        <Box key={index} sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <Skeleton
              variant="circular"
              width={40}
              height={40}
              sx={{ mr: 2 }}
            />
            <Box sx={{ flexGrow: 1 }}>
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton
                variant="text"
                width="100%"
                height={60}
                sx={{ my: 1 }}
              />
              <Skeleton variant="text" width={80} height={16} />
            </Box>
          </Box>
          {index < 2 && <Divider sx={{ mt: 2 }} />}
        </Box>
      ))}
    </Paper>
  );

  if (error) {
    return (
      <Container maxWidth="xxl">
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
        <Button startIcon={<ArrowBackIcon />} onClick={handleBackClick}>
          Go Back
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="xxxl" sx={{ px: { xs: 1, sm: 2 } }}>
      {/* Back Button */}
      <Box sx={{ mb: 2 }}>
        <Chip
          icon={<ArrowBackIcon />}
          label="Back"
          clickable
          onClick={handleBackClick}
          variant="outlined"
        />
      </Box>

      {/* Post Content */}
      {loading
        ? renderPostSkeleton()
        : post && (
            <Paper
              elevation={1}
              sx={{
                p: { xs: 1.5, sm: 2, md: 3 },
                mb: 3,
                bgcolor: "#212930",
                borderRadius: 5,
                boxShadow:
                  "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
                border: "1px solid #323d49",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                {post.isAuthor && (
                  <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
                    <CustomTooltip title="Edit Post">
                      <IconButton
                        color="primary"
                        onClick={() =>
                          handleOpenEdit("post", post._id, post.body)
                        }
                      >
                        <EditRounded
                          sx={{
                            fontSize: {
                              xs: "1.1rem",
                              sm: "1.2rem",
                              md: "1.4rem",
                            },
                          }}
                        />
                      </IconButton>
                    </CustomTooltip>

                    <CustomTooltip title="Delete Post">
                      <IconButton
                        color="error"
                        onClick={() => openConfirm("post")}
                      >
                        <DeleteRounded
                          sx={{
                            fontSize: {
                              xs: "1.1rem",
                              sm: "1.2rem",
                              md: "1.4rem",
                            },
                          }}
                        />
                      </IconButton>
                    </CustomTooltip>
                  </Box>
                )}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                <Avatar src={post.authorAvatar} sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "medium" }}>
                    {post.authorName}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <TimeIcon
                      sx={{ fontSize: 14, color: "text.secondary", mr: 0.5 }}
                    />
                    <Typography variant="body2" color="text.secondary">
                      {formatDate(post.createdAt)}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontSize: {
                    xs: "1.5rem",
                    sm: "1.6rem",
                    md: "1.75rem",
                  },
                }}
              >
                {post?.title}
              </Typography>

              {post.imageUrls && post.imageUrls.length > 0 && (
                <Box
                  sx={{
                    my: 2,
                    width: "100%",
                    maxWidth: "100%",
                  }}
                >
                  <Grid container spacing={0.5}>
                    {post.imageUrls.slice(0, 5).map((imageUrl, index) => {
                      let gridSize;
                      const totalImages = Math.min(post.imageUrls.length, 5);

                      if (totalImages === 1) {
                        gridSize = 12;
                      } else if (totalImages === 2) {
                        gridSize = 6;
                      } else if (totalImages === 3) {
                        if (index === 0) gridSize = 12;
                        else gridSize = 6;
                      } else if (totalImages === 4) {
                        if (index < 2) gridSize = 6;
                        else gridSize = 6;
                      } else {
                        // 5 images
                        if (index < 2) gridSize = 6;
                        else gridSize = 4;
                      }

                      return (
                        <Grid item xs={gridSize} key={index}>
                          <CustomTooltip title="Click to Preview">
                            <Box
                              component="img"
                              src={`${baseUrl}${imageUrl}`}
                              alt={`${post.title} - image ${index + 1}`}
                              sx={{
                                width: "100%",
                                height:
                                  totalImages === 1
                                    ? "400px"
                                    : totalImages === 2
                                    ? "250px"
                                    : totalImages === 3 && index === 0
                                    ? "200px"
                                    : totalImages === 3 && index > 0
                                    ? "150px"
                                    : "150px",
                                objectFit: "contain",
                                borderRadius: "4px",
                                cursor: "pointer",
                                display: "block",
                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  transform: "scale(1.02)",
                                  border: "1px solid rgba(255, 255, 255, 0.2)",
                                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                                },
                              }}
                              onClick={() => {
                                setLightboxIndex(index);
                                setLightboxOpen(true);
                              }}
                            />
                          </CustomTooltip>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              )}

              {/* {post.imageUrls && post.imageUrls.length > 0 && (
            <Box
              sx={{
                my: 3,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                alignItems: 'center'
              }}
            >
              {post.imageUrls.map((imageUrl, index) => (
                <img
                  key={index}
                  src={`${baseUrl}${imageUrl}`}
                  alt={`${post.title} - image ${index + 1}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '600px',
                    borderRadius: '8px',
                    objectFit: 'contain',
                    border: '1px solid #323d49'
                  }}
                />
              ))}
            </Box>
          )} */}

              {/* {post.imageUrl && (
            <Box sx={{ my: 3, textAlign: 'center' }}>
              <img
                src={`data:image/jpeg;base64,${post.imageUrl}`}
                alt={post.title}
                style={{
                  maxWidth: '100%',
                  maxHeight: '600px',
                  borderRadius: '8px',
                  objectFit: 'contain'
                }}
              />
            </Box>
          )} */}

              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                  fontSize: { xs: "0.9rem", sm: "1rem", md: "1.05rem" },
                  whiteSpace: "pre-wrap",
                }}
                dangerouslySetInnerHTML={{ __html: post.body }}
              />

              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant={
                    likedItems.has(`post-${post._id}`)
                      ? "contained"
                      : "outlined"
                  }
                  startIcon={
                    likedItems.has(`post-${post._id}`) ? (
                      <ThumbUpIcon
                        sx={{
                          fontSize: {
                            xs: "0.9rem",
                            sm: "1rem",
                            md: "1.2rem",
                          },
                        }}
                      />
                    ) : (
                      <ThumbUpOutlinedIcon
                        sx={{
                          fontSize: {
                            xs: "0.9rem",
                            sm: "1rem",
                            md: "1.2rem",
                          },
                        }}
                      />
                    )
                  }
                  onClick={() => handleLike(post._id, "post")}
                  size="small"
                  sx={{ borderRadius: 5 }}
                >
                  {likeCounts[`post-${post._id}`] || 0}
                </Button>
                <Box sx={{ width: 360 }}>
                  <AnchorTemporaryDrawer onClickHandleReply={handleReply} />
                </Box>
              </Box>
            </Paper>
          )}

      {/* Comments Section */}
      {commentsLoading && comments.length === 0 ? (
        renderCommentsSkeleton()
      ) : (
        <Paper
          elevation={1}
          sx={{
            p: { xs: 1.5, sm: 2, md: 3 },
            mt: 3,
            bgcolor: "#212930",
            borderRadius: 5,
            boxShadow:
              "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
            border: "1px solid #323d49",
          }}
        >
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            sx={{ fontWeight: "bold" }}
          >
            Comments ({comments.length})
          </Typography>

          {comments.length === 0 && !commentsLoading ? (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <PersonIcon
                sx={{ fontSize: 48, color: "text.secondary", mb: 1 }}
              />
              <Typography variant="body1" color="text.secondary">
                No comments yet. Be the first to comment!
              </Typography>
            </Box>
          ) : (
            <List>
              {comments.map((comment, index) => {
                const isOwner =
                  comment.commentorId === userId || post?.isAuthor;
                const isCommentOwner = comment.commentorId === userId;
                return (
                  <React.Fragment key={comment._id}>
                    <ListItem alignItems="flex-start" sx={{ px: 0 }}>
                      <ListItemAvatar>
                        <Avatar src={comment.authorAvatar} />
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: "bold", mr: 1 }}
                              >
                                {comment.commentorName}
                              </Typography>
                              <TimeIcon
                                sx={{
                                  fontSize: 12,
                                  color: "text.secondary",
                                  mr: 0.5,
                                }}
                              />
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {formatDate(comment.date)}
                              </Typography>
                            </Box>
                            <Box>
                              {/* Conditionally render the delete button based on the isOwner flag */}
                              {isOwner && (
                                <>
                                  {isCommentOwner && (
                                    <CustomTooltip title="Edit Comment">
                                      <IconButton
                                        color="primary"
                                        onClick={() =>
                                          handleOpenEdit(
                                            "comment",
                                            comment._id,
                                            comment.commentText
                                          )
                                        }
                                      >
                                        <EditRounded
                                          sx={{
                                            fontSize: {
                                              xs: "1.1rem",
                                              sm: "1.2rem",
                                              md: "1.4rem",
                                            },
                                          }}
                                        />
                                      </IconButton>
                                    </CustomTooltip>
                                  )}

                                  <CustomTooltip title="Delete Comment">
                                    <IconButton
                                      color="error"
                                      onClick={() =>
                                        openConfirm("comment", comment._id)
                                      }
                                    >
                                      <DeleteRounded
                                        sx={{
                                          fontSize: {
                                            xs: "1.1rem",
                                            sm: "1.2rem",
                                            md: "1.4rem",
                                          },
                                        }}
                                      />
                                    </IconButton>
                                  </CustomTooltip>
                                </>
                              )}
                            </Box>
                          </Box>
                        }
                        secondary={
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{
                                mb: 2,
                                fontSize: {
                                  xs: "0.9rem",
                                  sm: "1rem",
                                  md: "1.05rem",
                                },
                                whiteSpace: "pre-wrap",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: comment.commentText,
                              }}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() =>
                                  handleLike(comment._id, "comment")
                                }
                                color={
                                  likedItems.has(`comment-${comment._id}`)
                                    ? "primary"
                                    : "default"
                                }
                              >
                                {likedItems.has(`comment-${comment._id}`) ? (
                                  <ThumbUpIcon fontSize="small" />
                                ) : (
                                  <ThumbUpOutlinedIcon fontSize="small" />
                                )}
                              </IconButton>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {likeCounts[`comment-${comment._id}`] || 0}
                              </Typography>
                            </Box>
                          </Box>
                        }
                      />
                    </ListItem>
                    {index < comments.length - 1 && <Divider />}
                  </React.Fragment>
                );
              })}
            </List>
          )}
          {hasMoreComments && (
            <Box
              ref={commentsEndRef}
              sx={{ display: "flex", justifyContent: "center", py: 2 }}
            >
              {comments.length > 0 && commentsLoading && (
                <CircularProgress size={24} />
              )}
            </Box>
          )}
        </Paper>
      )}

      {/* Login Dialog */}
      <Dialog
        open={loginDialogOpen}
        onClose={() => setLoginDialogOpen(false)}
        PaperProps={{
          sx: {
            bgcolor: "#212930",
            borderRadius: 5,
            boxShadow:
              "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
            border: "1px solid #323d49",
          },
        }}
      >
        <DialogTitle>Login Required</DialogTitle>
        <DialogContent>
          <Typography>
            Please log in to interact with posts and comments.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLoginDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={navigateLogin}>
            Login
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for notifications */}

      {/* Confirmation Dialog for Deletions */}
      <Dialog
        open={confirmState.open}
        onClose={closeConfirm}
        PaperProps={{
          sx: {
            bgcolor: "#212930",
            borderRadius: 5,
            boxShadow:
              "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
            border: "1px solid #323d49",
          },
        }}
      >
        <DialogTitle>
          {confirmState.type === "post" ? "Delete Post?" : "Delete Comment?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmState.type === "post"
              ? "Are you sure you want to delete this post? This action cannot be undone."
              : "Are you sure you want to delete this comment?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirm}>Cancel</Button>
          <Button onClick={confirmDelete} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Dialog (shared for posts & comments) */}
      <EditDialog
        open={editState.open}
        handleClose={handleCloseEdit}
        initialValue={editState.content}
        categoryId={categoryId}
        title={post?.title}
        onSave={handleSaveEdit}
        type={editState.type}
      />

      {/* Lightbox for Images */}
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={slides}
        index={lightboxIndex}
        plugins={[Zoom, Download, Slideshow, Fullscreen]}
        zoom={{
          maxZoomPixelRatio: 3,
        }}
        slideshow={{
          autoplay: false,
          delay: 2000,
        }}
      />
    </Container>
  );
};

export default SinglePostView;
